var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.6433 10.0362C22.5529 10.0233 22.4625 10.0233 22.3721 10.0362C20.37 9.97159 18.7812 8.33117 18.7812 6.31617C18.7812 4.26242 20.4475 2.58325 22.5142 2.58325C24.5679 2.58325 26.2471 4.2495 26.2471 6.31617C26.2342 8.33117 24.6454 9.97159 22.6433 10.0362Z",
    fill: "#E0810F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.8535 18.9875C25.4068 19.9563 23.3789 20.3179 21.506 20.0725C21.9968 19.0133 22.2552 17.8379 22.2681 16.5979C22.2681 15.3063 21.9839 14.0792 21.4414 13.0071C23.3531 12.7488 25.381 13.1104 26.8406 14.0792C28.8814 15.4225 28.8814 17.6313 26.8535 18.9875Z",
    fill: "#E0810F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.31859 10.0362C8.40901 10.0233 8.49943 10.0233 8.58984 10.0362C10.5919 9.97159 12.1807 8.33117 12.1807 6.31617C12.1807 4.26242 10.5144 2.58325 8.44776 2.58325C6.39401 2.58325 4.71484 4.2495 4.71484 6.31617C4.72776 8.33117 6.31651 9.97159 8.31859 10.0362Z",
    fill: "#E0810F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.45971 16.598C8.45971 17.8509 8.73096 19.0392 9.2218 20.1113C7.40055 20.305 5.5018 19.9175 4.1068 19.0005C2.06596 17.6442 2.06596 15.4354 4.1068 14.0792C5.48888 13.1492 7.4393 12.7746 9.27346 12.9813C8.74388 14.0663 8.45971 15.2934 8.45971 16.598Z",
    fill: "#E0810F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6542 20.4987C15.5509 20.4858 15.4346 20.4858 15.3184 20.4987C12.9417 20.4212 11.043 18.4708 11.043 16.0683C11.043 13.6142 13.0192 11.625 15.4863 11.625C17.9405 11.625 19.9296 13.6142 19.9296 16.0683C19.9296 18.4708 18.0438 20.4212 15.6542 20.4987Z",
    fill: "#E0810F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.457 23.1724C9.50654 24.477 9.50654 26.6212 11.457 27.9128C13.6786 29.3982 17.3211 29.3982 19.5428 27.9128C21.4932 26.6082 21.4932 24.4641 19.5428 23.1724C17.334 21.687 13.6915 21.687 11.457 23.1724Z",
    fill: "#E0810F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.7c983a12977c6528ff70088e86915851.svg";
export { ForwardRef as ReactComponent };